// Mock data for Sanisolutions Inc website

export const companyInfo = {
  name: "Sanisolutions Inc",
  tagline: "Simplify. Optimize. Transform",
  description: "Sanisolutions Inc is a minority-owned SBA 8(a) small business technology solutions company that addresses the most challenging issues around Data & AI, Digital & Customer Experience, Cloud, Security, ERP, and Talent Management. We accomplish this by leveraging decades of experience listening to our clients, understanding their pain points, and developing and applying solutions to address them.",
  address: "4229 Lafayette Center Dr, Suite #1625, Chantilly, VA 20151",
  email: "info@sanisolutions.com",
  phone: "+1 (832) 942-8085",
};

export const navigation = [
  { name: "Home", href: "/", current: true },
  {
    name: "About",
    href: "/about",
    current: false,
    submenu: [
      { name: "Why Sanisolutions", href: "/about#why-sanisolutions" },
      { name: "Capabilities", href: "/capabilities" },
    ],
  },
  { name: "Services", href: "/services", current: false },
  { name: "Industries", href: "/industries", current: false },
  { name: "Insights", href: "/insights", current: false },
  { name: "Careers", href: "/careers", current: false },
  { name: "Contact Us", href: "/contact", current: false },
];

export const services = [
  {
    id: 1,
    name: "Data & AI",
    icon: "Database",
    description: "Leverage cutting-edge data analytics and artificial intelligence to drive business decisions.",
  },
  {
    id: 2,
    name: "Cloud / Modernization",
    icon: "Cloud",
    description: "Transform your infrastructure with modern cloud solutions and seamless migration services.",
  },
  {
    id: 3,
    name: "Security",
    icon: "Shield",
    description: "Protect your digital assets with comprehensive cybersecurity solutions.",
  },
  {
    id: 4,
    name: "PMO Support",
    icon: "Users",
    description: "Expert project management office support for successful project delivery.",
  },
];

export const certifications = [
  { id: 1, name: "CMMI SVC ML3", image: "https://images.unsplash.com/photo-1560472355-536de3962603?w=150&h=80&fit=crop" },
  { id: 2, name: "CMMI DEV ML3", image: "https://images.unsplash.com/photo-1560472355-536de3962603?w=150&h=80&fit=crop" },
  { id: 3, name: "SBA 8(a) Certified", image: "https://images.unsplash.com/photo-1560472355-536de3962603?w=150&h=80&fit=crop" },
  { id: 4, name: "MBE Certified", image: "https://images.unsplash.com/photo-1560472355-536de3962603?w=150&h=80&fit=crop" },
  { id: 5, name: "ISO 9001", image: "https://images.unsplash.com/photo-1560472355-536de3962603?w=150&h=80&fit=crop" },
  { id: 6, name: "ISO 20000", image: "https://images.unsplash.com/photo-1560472355-536de3962603?w=150&h=80&fit=crop" },
  { id: 7, name: "ISO 27001", image: "https://images.unsplash.com/photo-1560472355-536de3962603?w=150&h=80&fit=crop" },
];

export const industries = [
  {
    id: 1,
    name: "Federal, State, Local, Education and Non-Profit",
    shortName: "Government & Education",
    description: "The intersection of Government, Education and Non-Profit institutions offers an opportunity to leverage technology, transparency, and inclusivity to reshape governance, improve education outcomes, and prepare a digitally savvy workforce, despite challenges like funding gaps and geopolitical shifts.",
    image: "https://images.unsplash.com/photo-1624417963912-8532660d9de8?w=600&h=400&fit=crop",
    color: "from-blue-500/80 to-blue-900/90",
  },
  {
    id: 2,
    name: "Agriculture: Research & Innovation",
    shortName: "Agriculture",
    description: "The Sanisolutions team brings decades of expertise in agriculture, Soil Science, Plant breeding, plant pathology, and mycology with focus on data-driven agricultural research.",
    image: "https://images.unsplash.com/photo-1688677825986-4ffb926bafc9?w=600&h=400&fit=crop",
    color: "from-green-500/80 to-green-900/90",
  },
  {
    id: 3,
    name: "Communications, Media & Entertainment",
    shortName: "Media & Entertainment",
    description: "In the Communications, Media & Entertainment industries, balancing tech growth with ethics is crucial amidst digital expansion, while also embracing opportunities to transform the customer experience, diversify stories and engage audiences in new and meaningful ways.",
    image: "https://images.unsplash.com/photo-1764745222097-222e3b188c5a?w=600&h=400&fit=crop",
    color: "from-purple-500/80 to-purple-900/90",
  },
  {
    id: 4,
    name: "Manufacturing & Distribution",
    shortName: "Manufacturing",
    description: "In the Manufacturing & Distribution industries, automation, sustainability, and resilient supply chains bring challenges and opportunities, pushing industry players to streamline processes, adopt digital changes, and innovate to meet changing consumer needs while reducing environmental harm.",
    image: "https://images.unsplash.com/photo-1717386255773-1e3037c81788?w=600&h=400&fit=crop",
    color: "from-orange-500/80 to-orange-900/90",
  },
  {
    id: 5,
    name: "Healthcare",
    shortName: "Healthcare",
    description: "In Healthcare, delivering better patient outcomes amid technology advances and demographic changes creates an opportunity to use data, teamwork, and patient-focused methods to tackle health issues and ensure fair access to quality care.",
    image: "https://images.unsplash.com/photo-1619975102725-597d006b1a0f?w=600&h=400&fit=crop",
    color: "from-teal-500/80 to-teal-900/90",
  },
  {
    id: 6,
    name: "Transportation & Logistics",
    shortName: "Transportation",
    description: "In the Transportation & Logistics industry, digitalization, sustainability, and changing consumer needs drive the need for transformation, requiring supply chain optimization, automation for efficiency, and environmental mitigation despite challenges like infrastructure limitations and geopolitical issues.",
    image: "https://images.unsplash.com/photo-1634638022229-5a52221886dc?w=600&h=400&fit=crop",
    color: "from-indigo-500/80 to-indigo-900/90",
  },
];

export const caseStudies = [
  {
    id: 1,
    challenges: "Multi-vendor supply chain slowed production and time-to-market. Lack of global visibility and control resulted in slow market response.",
    benefits: "Visibility of end-to-end operations at global and local level through advanced dashboards and predictive analytics.",
    solution: "Leveraged integrated processes and optimized product configuration to improve global production capabilities.",
  },
  {
    id: 2,
    challenges: "Legacy systems hindering digital transformation efforts. Siloed data preventing comprehensive business insights.",
    benefits: "Unified data platform enabling real-time analytics and improved decision-making across departments.",
    solution: "Implemented cloud-native architecture with modern APIs and microservices for seamless integration.",
  },
  {
    id: 3,
    challenges: "Cybersecurity vulnerabilities exposing sensitive data. Compliance gaps with industry regulations.",
    benefits: "Enhanced security posture with 99.9% uptime and full regulatory compliance achieved.",
    solution: "Deployed comprehensive security framework with continuous monitoring and automated threat response.",
  },
];

export const awards = [
  { id: 1, name: "Top Workplaces 2024", year: "2024" },
  { id: 2, name: "Top Workplaces 2023", year: "2023" },
  { id: 3, name: "Best in Business", year: "2023" },
  { id: 4, name: "Excellence Award", year: "2022" },
];
